import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AudioService {
  triggerCompletionSound(): void {
    const audio = new Audio('assets/completed.mp3');
    audio.play().catch(err => console.warn(err));
  }
}
